import {
    DATE_LAST_62_DAYS_START_END,
    DATE_LAST_START_END,
    DATE_MONTH_END,
    DATE_MONTH_PREVIOUS_END,
    DATE_MONTH_PREVIOUS_START,
    DATE_MONTH_START,
    DATE_MONTH_START_END,
    DATE_PREVIOUS_MONTH_START_END,
    DATE_QUARTER_DAY_END,
    DATE_QUARTER_DAY_START,
    DATE_QUARTER_DAY_START_END,
    DATE_START_END_TODAY,
    DATE_TODAY,
    DATE_WEEK_END,
    DATE_WEEK_START,
    DATE_WEEK_START_END,
    DATE_YEAR_DAY_END,
    DATE_YEAR_DAY_START,
    DATE_YEAR_START_END
} from "@ui/datePicker/constants";
import moment from "moment";

export function getCalendarMatrix(date) {
    let calendarMatrix = []

    const startDay = new Date(date.getFullYear(), date.getMonth(), 1)
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const startDow = (startDay.getDay() + 6) % 7;
    const endDow = (lastDay.getDay() + 6) % 7;
    startDay.setDate(startDay.getDate() - startDow);

    lastDay.setDate(lastDay.getDate() + (6 - endDow));

    let week = []
    while (startDay <= lastDay) {
        week.push(new Date(startDay));
        if (week.length === 7) {
            calendarMatrix.push(week);
            week = []
        }
        startDay.setDate(startDay.getDate() + 1)
    }
    return calendarMatrix;
}

export const getFormatDateByKey = (key) => {

    const today = new Date()

    if (key.includes(DATE_TODAY)) {
        return today
    }
    if (key.includes(DATE_MONTH_START)) {
        return new Date(today.getFullYear(), today.getMonth(), 1);
    }
    if (key.includes(DATE_WEEK_START)) {
        today.setHours(0, 0, 0, 0);
        var start_week_date = new Date(today);
        start_week_date.setDate(
            start_week_date.getDate() - start_week_date.getDay() + 1
        );
        return start_week_date;
    }
    if (key.includes(DATE_WEEK_END)) {
        today.setHours(0, 0, 0, 0);
        var end_week_date = new Date(today);
        end_week_date.setDate(
            end_week_date.getDate() - end_week_date.getDay() + 7
        );
        return end_week_date;
    }

    if (key.includes(DATE_MONTH_END)) {
        return new Date(today.getFullYear(), today.getMonth() + 1, 0);
    }

    if (key.includes(DATE_MONTH_PREVIOUS_START)) {
        const current = moment().month()
        const previous = current - 1;
        const year = moment().year();
        const previousMonth = moment().year(year).month(previous).date(1)
        return new Date(previousMonth)

    }

    if (key.includes(DATE_MONTH_PREVIOUS_END)) {
        const current = moment().month()
        const previous = current - 1;
        const year = moment().year();
        const previousMonth = moment().year(year).month(previous).endOf('month')
        return new Date(previousMonth)

    }

    if (key.includes(DATE_YEAR_DAY_START)) {
        const startDay = moment().dayOfYear(1)
        return new Date(startDay)

    }

    if (key.includes(DATE_YEAR_DAY_END)) {
        const endDay = moment(new Date()).endOf('year');
        return new Date(endDay)

    }

    if (key.includes(DATE_QUARTER_DAY_START)) {
        const startDay = moment().startOf('quarter')
        return new Date(startDay)

    }


    if (key.includes(DATE_QUARTER_DAY_END)) {
        const endDay = moment().endOf('quarter');
        return new Date(endDay)

    }

}

export const getDateStartEndTemplateByKey = (key) => {
    switch (key) {
        case DATE_START_END_TODAY : {
            return {
                dateStart: moment().startOf('day').format(),
                dateEnd: moment().endOf('day').format(),
            }
        }
        case DATE_LAST_START_END : {
            return {
                dateStart: moment().subtract(1, 'day').startOf('day'),
                dateEnd: moment().subtract(1, 'day').endOf('day'),

            }
        }
        case DATE_WEEK_START_END : {
            return {
                dateStart: moment().startOf('week'),
                dateEnd: moment().endOf('week'),

            }
        }
        case DATE_MONTH_START_END : {
            return {
                dateStart: moment().startOf('month'),
                dateEnd: moment().endOf('month'),

            }
        }
        case DATE_PREVIOUS_MONTH_START_END : {
            return {
                dateStart: moment().subtract(1, 'months').startOf('month'),
                dateEnd: moment().subtract(1, 'months').endOf('month'),

            }
        }
        case DATE_QUARTER_DAY_START_END : {
            return {
                dateStart: moment().startOf('quarter'),
                dateEnd: moment().endOf('quarter'),

            }
        }
        case DATE_LAST_62_DAYS_START_END : {
            return {
                dateStart: moment().subtract(61, 'days').startOf('day'),
                dateEnd: moment().endOf('day'),
            }
        }
        case DATE_YEAR_START_END : {
            return {
                dateStart: moment().startOf('year'),
                dateEnd: moment().endOf('year'),

            }
        }
    }
    return {
        dateStart: getFormatDateByKey(DATE_TODAY),
        dateEnd: getFormatDateByKey(DATE_TODAY),
    }
}

export const checkDateIsTemplate = (date) => {
    if (typeof date === 'string' && date?.includes('{')) {
        return true;
    }
}

export const getInitialValueDatePickerTemplate = (value) => {
    const isTemplate = checkDateIsTemplate(value)
    if (isTemplate) {
        return value;
    }
    return DATE_QUARTER_DAY_START
}

export const getInitialValueDatePickerFixed = (value, format) => {
    const isTemplate = checkDateIsTemplate(value)
    if (isTemplate) {
        return moment(new Date(), format).format()
    }

    // const date = moment.isDate(value) ? value : new Date()
    return moment(value, format).format()
}